import { PriceConstantS } from '@modules/Price/S/Constant/module/PriceConstantS';

interface CurrencyInfo {
  code: string;
  decimal: number; // 마플샵에서 보여주는 통화 소수점 자리
  rate: number; // KRW 기준 환율
}
export class Currency {
  private static readonly CURRENCIES = new Map<string, CurrencyInfo>();

  private constructor(
    private readonly code: string,
    private readonly info: CurrencyInfo,
  ) {}

  static readonly KRW = Currency.register('KRW', {
    code: 'KRW',
    decimal: 0,
    rate: 1, // KRW를 기준 통화로 설정
  });

  static readonly USD = Currency.register('USD', {
    code: 'USD',
    decimal: PriceConstantS.DIGIT,
    rate: PriceConstantS.PROFIT_EXCHANGE_RATE_EN, // 1 USD = 1200 KRW
  });

  static readonly JPY = Currency.register('JPY', {
    code: 'JPY',
    decimal: 0,
    rate: PriceConstantS.PROFIT_EXCHANGE_RATE_JP, // 1 JPY = 8.5 KRW
  });

  private static register(code: string, info: CurrencyInfo): Currency {
    const currency = new Currency(code, info);
    this.CURRENCIES.set(code, info);
    return currency;
  }

  static of(code: string): Currency {
    const info = this.CURRENCIES.get(code);
    if (!info) {
      throw new Error(`Unknown currency: ${code}`);
    }
    return new Currency(code, info);
  }

  // 환율 계산 (from 통화를 to 통화로 변환하는 환율)
  static getExchangeRate(from: Currency, to: Currency): number {
    if (from.equals(to)) {
      return 1;
    }

    return from.info.rate / to.info.rate;
  }

  getCode(): string {
    return this.code;
  }

  getRate(): number {
    return this.info.rate;
  }

  getDecimal(): number {
    return this.info.decimal;
  }

  equals(other: Currency): boolean {
    return this.code === other.code;
  }
}
